<template>
	<el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item prop="list">
            <mn-form-table v-model="list" :addTemplate="addTemplate" drag-sort placeholder="暂无数据">
                <template v-for="(item,index) in formlist" :key="index">
                    <el-table-column :prop="item.key" :label="item.label" width="180">
                        <template #header>
                            <div class="header">
                                <span>{{item.label}}</span>
                                <div class="icon" v-if="isEdit">
                                    <el-button type="danger" icon="el-icon-delete" size="small" plain circle @click="rowDel(index)"></el-button>
                                </div>
                            </div>
                        </template>
                        <template #default="scope">
                            <template v-if="item.type=='cascader'">
                                <el-cascader style="width: 100%;" separator="-" collapse-tags :props="item.props" v-model="scope.row[item.key]" :options="item.options" />
                            </template>
                            <template v-else-if="item.type=='number'">
                                <el-input type="number" v-model="scope.row[item.key]" placeholder="请输入内容"></el-input>
                            </template>
                            <template v-else>
                                <el-input v-model="scope.row[item.key]" placeholder="请输入内容"></el-input>
                            </template>
                        </template>
                    </el-table-column>
                </template>
            </mn-form-table>
        </el-form-item>
        <el-form-item>
            <!-- <el-button type="primary" @click="submitForm">保存</el-button> -->
            <el-button @click="visible=true" v-if="isEdit">添加字段</el-button>
        </el-form-item>
    </el-form>
    <el-dialog title="添加字段" v-model="visible" :width="500" destroy-on-close @closed="visible=false">
		<el-form :model="form1" :rules="rules1" :disabled="mode=='show'" ref="dialogForm" label-width="100px">
			<el-form-item label="字段名称" prop="label">
				<el-input v-model="form1.label" placeholder="请输入字段名称" clearable></el-input>
			</el-form-item>
            <el-form-item label="键名" prop="key">
                <el-input v-model="form1.key" placeholder="请输入字段键名" clearable></el-input>
			</el-form-item>
		</el-form>
		<template #footer>
			<el-button @click="visible=false" >取 消</el-button>
			<el-button v-if="mode!='show'" type="primary" :loading="isSaveing" @click="submit()">添加</el-button>
		</template>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			modelValue: {
				type: Object,
                default:()=>{
                    return {}
                }
			},
            form:{
                type:Object,
                default:()=>{
                    return {}
                }
            },
            isEdit:{
                type:Boolean,
                default:true
            }
		},
		data() {
			return {   
                visible:false,
                formlist:[
                   
                ],
				addTemplate: {
					
				},
                form1:{
                    label:'',
                    key:''
                },
                list: [
                ],
				rules: {
					title: [
						{required: true, message: '请上传', trigger: 'blur'}
					]
				},
                rules1: {
					label: [
						{required: true, message: '请输入字段名称'}
					],
					key: [
						{required: true, message: '请输入字段键值'}
					]
				}
			}
		},
        watch:{
			list:{
                handler(){
				    this.$emit('update:modelValue', this.list)
                },
				deep: true
			}
		},
		mounted() {
            this.formlist = this.form.formlist
            Object.keys(this.formlist).map((key)=>{
                this.addTemplate[this.formlist[key].key] = ""
            })
            this.$nextTick(()=>{
                this.list = this.form.value
            })
            this.$emit('update:modelValue', this.list);
		},
		methods: {
			submit(){
                this.$refs.dialogForm.validate(async (valid) => {
					if (valid) {
						this.addTemplate[this.form1.key] = ''
                        let a = {
                            label:this.form1.label,
                            key:this.form1.key
                        }
                        this.formlist.push(a);
                        for (const key in this.list) {
                            this.list[key][this.form1.key] = ''
                        }
                        this.form1 = {
                            label:'',
                            key:''
                        };
                        this.visible=false
					}
				})
                
            },
            rowDel(index){
                for (const key in this.list) {
                    delete this.list[key][this.formlist[index].key];
                }
                delete this.addTemplate[this.formlist[index].key]
                this.formlist.splice(index,1);
            }
		}
	}
</script>

<style scoped lang="scss">
.el-form-item .el-form-item{
    margin-bottom: 18px;
}
.header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    .icon{
        display: none;
    }
}
.header:hover{
    .icon{
        display: block;
    }
}
</style>
